/*
 * Check if saved card is expired based on date
 * @param date : string // date comes in '3/2030' format
 * @returns boolean
 */
export function isCardExpired(date: string): boolean {
    const month = parseInt(date.substring(0, date.indexOf('/')), 10);
    const year = parseInt(date.substring(date.indexOf('/') + 1), 10);
    if (month && year) {
        const date = new Date();
        const currentMonth = date.getMonth() + 1;
        const currentYear = date.getFullYear();
        return currentYear > year || (currentYear === year && currentMonth > month);
    }
    return false;
}